module.exports = __webpack_public_path__ + "img/goblin.5472832c.png";